import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { getAccessToken } from '@/services/tokenStorage';

let echoInstance: Echo<'pusher'> | null = null;

function buildEchoOptions(): ConstructorParameters<typeof Echo<'pusher'>>[0] {
  const apiUrl = (import.meta.env.VITE_API_URL as string).replace(/\/$/, '');
  const key = import.meta.env.VITE_PUSHER_APP_KEY as string | undefined;
  const cluster = (import.meta.env.VITE_PUSHER_APP_CLUSTER as string | undefined) ?? 'mt1';
  const wsHost = import.meta.env.VITE_PUSHER_HOST as string | undefined;
  const wsPortRaw = import.meta.env.VITE_PUSHER_PORT as string | undefined;
  const scheme = (import.meta.env.VITE_PUSHER_SCHEME as string | undefined) ?? 'https';

  const base: Record<string, unknown> = {
    broadcaster: 'pusher',
    key,
    cluster,
    // The token is read on every channel authorisation, not once when Echo is built. Channels
    // are now joined throughout a session (searchDocumentAnnouncements), so one joined after
    // the token was refreshed would otherwise send the old token and be refused.
    channelAuthorization: {
      endpoint: `${apiUrl}/broadcasting/auth`,
      transport: 'ajax',
      headers: { Accept: 'application/json' },
      headersProvider: () => ({ Authorization: `Bearer ${getAccessToken() ?? ''}` }),
    },
    enabledTransports: ['ws', 'wss'],
  };

  if (wsHost) {
    const wsPort = wsPortRaw !== undefined && wsPortRaw !== '' ? Number(wsPortRaw) : scheme === 'https' ? 443 : 6001;
    base.wsHost = wsHost;
    base.wsPort = wsPort;
    base.wssPort = wsPort;
    base.forceTLS = scheme === 'https';
    base.disableStats = true;
  } else {
    base.forceTLS = true;
  }

  return base as ConstructorParameters<typeof Echo<'pusher'>>[0];
}

export function getEcho(): Echo<'pusher'> | null {
  const key = import.meta.env.VITE_PUSHER_APP_KEY;
  if (key === undefined || key === '') {
    return null;
  }
  if (echoInstance !== null) {
    return echoInstance;
  }

  window.Pusher = Pusher;
  echoInstance = new Echo<'pusher'>(buildEchoOptions());

  return echoInstance;
}

export function disconnectEcho(): void {
  if (echoInstance !== null) {
    echoInstance.disconnect();
    echoInstance = null;
  }
}
